import { PayloadAction } from "@reduxjs/toolkit";
import { ProposalState } from "..";

type SetPendingMaterialInformationParams = {
  index: number;
  productId: number;
  packagedProductId: number;
  price: number;
};

function SetPendingMaterialInformationReducer(
  state: ProposalState,
  {
    payload: { index, productId, packagedProductId, price },
  }: PayloadAction<SetPendingMaterialInformationParams>,
) {
  if (index < 0 || index >= state.pendingMaterials.length) return;
  state.pendingMaterials[index].formId = `${productId}`;
  state.pendingMaterials[index].productId = productId;
  state.pendingMaterials[index].commercialConditions.packagedProductId =
    packagedProductId;
  state.pendingMaterials[index].commercialConditions.price = price;
}

export default SetPendingMaterialInformationReducer;
